class CustomSubscription extends HTMLElement {
    constructor(){
        super();
        this.product;
        this.productID;
        this.variantID;
        this.widget;
        this.widgetTemplate;
        this.sellingPlanGroup;
        this.init();
    }

    init(){
        this.variantID = Number(document.querySelector('.product-variant-id').value);
        this.productID = document.querySelector('.rc-custom-widget').getAttribute('data-product-id');

        const data = JSON.parse(document.getElementById('custom-widget-data').textContent);
        this.product = data.product;
        this.widget = {
            select_subscription_first: true,
            subscribe_message: 'Subscribe & Save',
            subscribe_without_discount_message: 'Subscribe',
            onetime_message: 'One-time purchase'
        };

        // Use the SKIO selling plan group
        this.sellingPlanGroup = this.product.selling_plan_groups.find(g => g.app_id === 'SKIO') || this.product.selling_plan_groups[0];

        this.widgetTemplate = document.querySelector('.rc-custom-widget ');
        this.widgetTemplate.classList.add('radio-group');

        if (this.product.id != null) {
            this.widgetTemplate.classList.remove('hidden');
            this.renderWidget();
        }
    }

    formatPrice(cents) {
        return (cents / 100).toFixed(2);
    }

    getSellingVariant(variantID) {
        return this.product.variants.find(v => v.id === variantID);
    }

    getVariantAllocations(sellingVariant) {
        const groupId = this.sellingPlanGroup.id;
        return sellingVariant.selling_plan_allocations.filter(a => a.selling_plan_group_id === groupId);
    }

    renderWidget(){
        let widgetTemplate = this.widgetTemplate,
            variantID = this.variantID,
            widget = this.widget,
            prod = this.product,
            sellingVariant = this.product.variants.find(obj => obj.id === variantID),
            allocations = this.getVariantAllocations(sellingVariant),
            sellingPlan = '',
            priceEl,
            price = this.formatPrice(sellingVariant.price),
            compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
            subscribePrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price;

        //subscription is selected first
        if(this.widget.select_subscription_first){
            sellingPlan = allocations[0].selling_plan_id;
            price = subscribePrice;
        }

        // Determine the correct price element based on whether there is a compare-at price
        if (compareAtPrice) {
            priceEl = document.querySelector('.product-page-price .price__sale .price-item.price-item--sale');
        } else {
            priceEl = document.querySelector('.product-page-price .price__regular .price-item.price-item--regular')
        }

        // input element for the selling plan and add it to product form
        let sellingPlanInput = document.createElement('input');
            sellingPlanInput.classList.add('selling-plan-input')
            sellingPlanInput.name = 'selling_plan';
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.value = sellingPlan;
            document.querySelector('.product-form form').appendChild(sellingPlanInput)

        // should change how this
        document.querySelector('.one-time .radio-template .radio').checked = false;
        document.querySelector('.subscription .radio-template .radio').checked = false;

        this.renderSubscriptionRadio(sellingVariant);
        this.renderOneTimeRadio(sellingVariant);

        document.querySelector('.product-variant-id').addEventListener('change', this.updateRadioWidget.bind(this));

        // Update the product price with the correct price
        this.updatePrice(price, subscribePrice, compareAtPrice);
    }

    renderSubscriptionRadio(sellingVariant){
        let widget = this.widget,
            prod = this.product,
            widgetTemplate = this.widgetTemplate,
            subscribeText = widget.subscribe_without_discount_message,
            allocations = this.getVariantAllocations(sellingVariant),
            price = this.formatPrice(sellingVariant.price),
            discountedPrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price,
            compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
            discount = (parseFloat(price) > parseFloat(discountedPrice)),
            subscribePrice = price,
            _this = this;

        // if a discount is applied, change the text to the subscribe with discount message and set the price to the discounted price
        if (discount) {
            subscribePrice = discountedPrice;
            subscribeText = widget.subscribe_message;
            let discountValue = this.sellingPlanGroup.selling_plans[0].price_adjustments[0].value;
            widgetTemplate.querySelector('.subscription .save').innerText = 'Save ' + discountValue + '%'
        }

        widgetTemplate.querySelector('.subscription .option-text').innerHTML = subscribeText;
        widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice;

        // //setting subscription radio as the default choice
        if(widget.select_subscription_first){
            widgetTemplate.querySelector('.subscription.radio-wrapper').classList.add('radio-active');
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = true;

                document.querySelector('.rc-custom-widget').setAttribute('data-selected', 'subscription');
                document.querySelector('.product-page-price .price-item.price-item--regular').innerText = '$' + subscribePrice;
        }

        allocations.forEach(item => {
            let option = document.createElement('div'),
                plan = this.sellingPlanGroup.selling_plans.find(obj => obj.id == item.selling_plan_id),
                discount = plan.price_adjustments[0].value + '%';

            option.className = "delivery"
            option.value = plan.id;
            option.innerText = plan.name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', this.formatPrice(item.price));

            widgetTemplate.querySelector('.shipping-dates').appendChild(option);
        })

        const deliveryBtn = widgetTemplate.querySelectorAll('.delivery');
        deliveryBtn[0].classList.add('selected');
        deliveryBtn.forEach(btn => {
            btn.addEventListener('click', function(){
                widgetTemplate.querySelector('.shipping-dates .delivery.selected').classList.remove('selected');
                btn.classList.add('selected');
                document.querySelector('.product-form form .selling-plan-input').value = btn.value;
            })
        })

        widgetTemplate.querySelector('.subscription .radio-template .radio').addEventListener('change', this.handleSubscriptionChange.bind(this));
    }


    handleSubscriptionChange(ev){
        if (ev.target.checked){
            let widgetTemplate = this.widgetTemplate,
                sellingVariant = this.getSellingVariant(Number(document.querySelector('.product-variant-id').value)),
                allocations = this.getVariantAllocations(sellingVariant),
                price = this.formatPrice(sellingVariant.price),
                compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
                subscribePrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price,
                sellingPlanInput = document.querySelector('.product-form form .selling-plan-input');


            sellingPlanInput.value = widgetTemplate.querySelector('.shipping-dates .delivery.selected').value

            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = false;
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.subscription .radio-template .filler').classList.remove('hidden')
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.remove('hidden')
            widgetTemplate.querySelector('.radio-wrapper.radio-active').classList.remove('radio-active');
            widgetTemplate.querySelector('.subscription.radio-wrapper').classList.add('radio-active');


            document.querySelector('.rc-custom-widget').setAttribute('data-selected', 'subscription');
            this.updatePrice(price, subscribePrice, compareAtPrice);
        }
    }

    renderOneTimeRadio(sellingVariant){
        let widgetTemplate = this.widgetTemplate,
            widget = this.widget,
            price = this.formatPrice(sellingVariant.price),
            oneTimeText = widget.onetime_message;

        widgetTemplate.querySelector('.one-time .option-text').innerText = oneTimeText;
        widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + price;

        // if the widget is set to not select the subscription radio by default, add the active class and check the radio button
        if (!widget.select_subscription_first) {
            widgetTemplate.querySelector('.subscription .radio-template .filler').classList.add('hidden');
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.add('hidden');
            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.one-time.radio-wrapper').classList.add('radio-active');
            document.querySelector('.rc-custom-widget').setAttribute('data-selected', 'one-time');
        }

        widgetTemplate.querySelector('.one-time .radio-template .radio').addEventListener('change', this.handleOneTimeChange.bind(this));
    }

    handleOneTimeChange(ev){
        if(ev.target.checked){
            let widgetTemplate = this.widgetTemplate,
                widget = this.widget,
                sellingVariant = this.getSellingVariant(Number(document.querySelector('.product-variant-id').value)),
                price = this.formatPrice(sellingVariant.price),
                compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
                sellingPlanInput = document.querySelector('.product-form form .selling-plan-input');

            sellingPlanInput.value = '';
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = false;
            widgetTemplate.querySelector('.subscription .radio-template .filler').classList.add('hidden');
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.add('hidden');
            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.radio-wrapper.radio-active').classList.remove('radio-active');
            widgetTemplate.querySelector('.one-time.radio-wrapper').classList.add('radio-active');

            document.querySelector('.rc-custom-widget').setAttribute('data-selected', 'one-time');
            this.updatePrice(price, null, compareAtPrice);
        }
    }

    updateRadioWidget(){
        let prod = this.product,
            widgetTemplate = this.widgetTemplate,
            variantID = Number(document.querySelector('.product-variant-id').value),
            sellingVariant = this.getSellingVariant(variantID),
            allocations = this.getVariantAllocations(sellingVariant),
            priceContainer = document.querySelector('.product-page-price .price'),
            price = this.formatPrice(sellingVariant.price),
            subscribePrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price,
            compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
            subscriptionRadio = widgetTemplate.querySelector('.subscription .radio-template .radio'),
            oneTimeRadio = widgetTemplate.querySelector('.one-time .radio-template .radio'),
            sellingPlanInput = document.querySelector('.product-form form .selling-plan-input');

        priceContainer.classList.add('recharge-price-modifier');

        widgetTemplate.querySelector('.subscription .shipping-dates').innerHTML = ''

        allocations.forEach((item, i) => {
            let option = document.createElement('div'),
                plan = this.sellingPlanGroup.selling_plans.find(obj => obj.id == item.selling_plan_id),
                discount = plan.price_adjustments[0].value + '%';

            if (i === 0) {
                // set the subscribePrice variable to the price of the first plan
                subscribePrice = this.formatPrice(item.price);
                document.querySelector('.subscription .option-price').innerText = '$' + subscribePrice;
            }

            // // attach necessary data to the option
            option.className = "delivery"
            option.value = plan.id;
            option.innerText = plan.name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', this.formatPrice(item.price));

            widgetTemplate.querySelector('.subscription .shipping-dates').appendChild(option);
        })

        widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + this.formatPrice(sellingVariant.price);

        const deliveryBtn = widgetTemplate.querySelectorAll('.delivery');
        deliveryBtn[0].classList.add('selected');
        if(document.querySelector('.rc-custom-widget').getAttribute('data-selected') == 'subscription'){
            document.querySelector('.product-form form .selling-plan-input').value = deliveryBtn[0].value;
        } else if(document.querySelector('.rc-custom-widget').getAttribute('data-selected') == 'one-time'){
            document.querySelector('.product-form form .selling-plan-input').value = '';
        }
        deliveryBtn.forEach(btn => {
            btn.addEventListener('click', function(){
                widgetTemplate.querySelector('.shipping-dates .delivery.selected').classList.remove('selected');
                btn.classList.add('selected');
                document.querySelector('.product-form form .selling-plan-input').value = btn.value;
            })
        })

        requestAnimationFrame(() => {
            this.updatePrice(price, subscribePrice, compareAtPrice);
        });
    }

    // updates the price when the variant or selling plan is changed
    updatePrice(price, subscribePrice, compareAtPrice) {
        let selected = document.querySelector('.rc-custom-widget').getAttribute('data-selected'),
            priceContainer = document.querySelector('.product__info-wrapper .product-page-price'),
            priceEl,
            newPrice;

        if (selected == 'one-time') {
            newPrice = price;
        } else if (selected == 'subscription') {
            newPrice = subscribePrice;
        }

        if (compareAtPrice != null ) {
            priceContainer.querySelector('.price').classList.add('price--on-sale')
            priceEl = priceContainer.querySelector('.price__sale .price-item.price-item--sale');
            priceContainer.querySelector('.price__sale .price-item.price-item--regular').innerText = '$' + compareAtPrice
        } else {
            priceContainer.querySelector('.price').classList.remove('price--on-sale');
            priceEl = priceContainer.querySelector('.price__regular .price-item.price-item--regular');
        }

        priceEl.innerText = '$' + newPrice;
    }
}

customElements.define('custom-subscription', CustomSubscription);
